export enum FileType {
  T2_01 = "T2-01",
  T2_02 = "T2-02",
  T2_03 = "T2-03",
  T2_08 = "T2-08",
  T2_24 = "T2-24",
  T2_26 = "T2-26",
  T2_27 = "T2-27",
  T2_30 = "T2-30",
  T2_XX = "T2-XX",
}

export type DisableValidationConfig = {
  hasDisableValidationToggle: boolean;
  disableValidationLabel: string;
  disableValidationWarning: string;
};

export type FileTypeContext = {
  endpointUrl: string;
  description: string;
  disableValidationConfig?: DisableValidationConfig;
};

const FileTyeConfiguration = new Map<FileType, FileTypeContext>([
  [
    FileType.T2_01,
    {
      endpointUrl: "/area-model/upload",
      description: "T2-01: Tenant Data",
    },
  ],

  [
    FileType.T2_02,
    {
      endpointUrl: "/expenses",
      description: "T2-02: Property Finance Data",
      disableValidationConfig: {
        hasDisableValidationToggle: true,
        disableValidationLabel: "Disable date validation",
        disableValidationWarning:
          "You are trying to load old FiBu data (older than last month); this is only applicable in exceptional " +
          "cases. Please choose the correct load file if you intend to deliver current FiBu data. Otherwise, " +
          "please be aligned with your UBS contact regarding the data delivery.",
      },
    },
  ],
  [FileType.T2_03, { endpointUrl: "/budgets", description: "T2-03: Property Budget Data" }],
  [
    FileType.T2_08,
    {
      endpointUrl: "/valuations",
      description: "T2-08: Valuations",
    },
  ],

  [FileType.T2_24, { endpointUrl: "/activations", description: "T2-24: Activations" }],
  [
    FileType.T2_26,
    {
      endpointUrl: "/budget-adjustments",
      description: "T2-26: Property Compensations",
    },
  ],
  [
    FileType.T2_27,
    {
      endpointUrl: "/rental-contracts/market-rent",
      description: "T2-27: Market Rent",
    },
  ],
  [
    FileType.T2_30,
    {
      endpointUrl: "/rental-contracts/expiring",
      description: "T2-30: Expiring Rental Contracts",
    },
  ],
  [
    FileType.T2_XX,
    {
      endpointUrl: "/rental-contracts/comment",
      description: "T2-XX: Rental Property Comment",
    },
  ],
]);

export const getFileTypeConfiguration = (fileType: FileType): FileTypeContext | undefined =>
  FileTyeConfiguration.get(fileType);

export const getAllFileTypes = (): [FileType, FileTypeContext][] => Array.from(FileTyeConfiguration);
